<template>
  <van-dialog class="login-dialog" :value="value" :show-confirm-button="false">
    <div class="login-header">
      <div :class="{ 'login-title': true }" v-html="getTitle"></div>
    </div>
    <van-form
      class="login-form"
      @submit="onSubmit"
      @failed="onFailed"
      :show-error="false"
      :show-error-message="false"
    >
      <div class="get-code">
        <van-field
          class="field-input"
          v-model.trim="phone"
          placeholder="请输入手机号"
          :rules="[
            {
              required: true,
              message: '请输入手机号',
            },
            {
              pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
              message: '请输入正确的11位手机号',
            },
          ]"
        ></van-field>
        <div
          :class="{ code: true, countDown: countDown > 0 }"
          @click="getVerifyCode"
        >
          {{ countDown > 0 ? `${countDown}s` : "获取验证码" }}
        </div>
      </div>
      <van-field
        class="field-input"
        v-model.trim="code"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      />
      <div class="error-text">{{ error }}</div>
      <div class="form-submit">
        <van-button round size="large" block type="info" native-type="submit"
          >立即绑定</van-button
        >
      </div>
      <div class="tips">不影响使用，后续可用此手机号登录使用GoGo大会员权益</div>
    </van-form>
  </van-dialog>
</template>

<script>
import { loginBind, register } from "@/apis/home";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  props: ["type", "value", "close", "resolve", "reject", "ns"],
  data() {
    return {
      phone: "",
      code: "",
      countDown: 0,
      error: "",
      session_code: "",
    };
  },

  mounted() {},
  computed: {
    ...mapState(["namespace", "namespaceInfo", "userInfo"]),
    getTitle() {
      return "请先输入常用手机号绑定账号";
    },
  },

  methods: {
    ...mapMutations(["changeState"]),
    ...mapActions(["fetchUserInfo"]),
    toAgreement() {
      location.href = "https://cdn.xiangshuheika.com/h5/agreement/kaisa.html";
    },
    async onSubmit() {
      if (!this.session_code) {
        this.$toast("请先获取短信验证码");
        return;
      }
      this.error = "";
      const loading = this.$loading();
      try {
        await loginBind({
          unique_id: this.userInfo.unique_id,
          namespace: this.ns || this.namespace,
          phone_number: this.phone,
          otp: this.code,
          session_code: this.session_code,
        });
        this.$toast("绑定成功");
        this.resolve();
        this.close();
      } catch (e) {
        console.log(e);
        if (e && e.code === 50201) {
          this.$toast("短信验证码错误");
        }
      } finally {
        loading.clear();
      }
    },
    // 关闭弹窗时 清空form内容
    // 此方法由组件实例调用
    beforeClose() {
      this.phone = "";
      this.code = "";
      this.error = "";
    },

    onFailed({ errors }) {
      if (errors.length) {
        this.error = errors[0].message;
      }
    },
    async getVerifyCode() {
      if (this.countDown > 0) {
        return;
      }
      if (!this.phone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.phone)) {
        this.$toast("请输入正确的11位手机号");
        return;
      }

      const toast = this.$loading();
      try {
        const res = await register({
          phone_number: this.phone,
          app_name: this.$getConfigValue("APP_NAME"),
        });
        this.$toast("验证码已发送");
        this.countDown = 60;
        this.session_code = res.session_code;
        this.timer = setInterval(() => {
          this.countDown--;
          if (this.countDown == 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } finally {
        toast.clear();
      }
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.changeState({ showLogin: false });
      }
    },
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
.login-dialog {
  overflow: inherit;
}
.login-header {
  text-align: center;
  padding: 30px 24px 30px;
  position: relative;
}
.login-icon {
  position: absolute;
  top: -60px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 120px;
  background: url("../../assets/images/icon-s.png") no-repeat;
  background-size: 100%;
}
.login-title {
  line-height: 28px;
  font-size: @font-lg;
  font-weight: bold;
  &.free-pay-title {
    margin-top: 20px;
  }
}

.login-form {
  padding: 0 8px;
}
.login-desc {
  line-height: 25px;
  font-size: 16px;
}
.get-code {
  position: relative;
}
.field-input {
  padding-top: 13px;
  padding-bottom: 13px;
}
.code {
  position: absolute;
  right: 16px;
  top: 12px;
  width: 80px;
  color: @red-color;
  border: 1px solid;
  border-color: currentColor;
  line-height: 26px;
  height: 26px;
  text-align: center;
  border-radius: 26px;
  font-size: @font-sm;
  box-sizing: border-box;
  &.countDown {
    color: @text-gray-color;
  }
}
.form-submit {
  margin: 18px 16px 14px;
}
.error-text {
  color: @red-color;
  font-size: @font-sm;
  line-height: 20px;
  padding: 0 16px;
  margin-top: 10px;
  height: 20px;
}

.login-agreement {
  text-align: center;
  font-size: 12px;
  color: #666;
  padding-bottom: 10px;
}
.login-agreement-text {
  color: #0091ff;
}
.tips {
  font-size: 12px;
  color: #999;
  text-align: center;
  padding: 0px 20px 5px;
}
</style>